import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Landing from "@/pages/Landing";
import HiddenGate from "@/pages/HiddenGate";
import MerchPortal from "@/pages/MerchPortal";
import AdminPanel from "@/pages/AdminPanel";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App scanline-overlay">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/signal" element={<Landing />} />
          <Route path="/merch" element={<MerchPortal />} />
          <Route path="/access/:slug" element={<HiddenGate />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;